import { render, staticRenderFns } from "./r-trader-order-table.vue?vue&type=template&id=6f20a9a1"
import script from "./r-trader-order-table.vue?vue&type=script&lang=js"
export * from "./r-trader-order-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f20a9a1')) {
      api.createRecord('6f20a9a1', component.options)
    } else {
      api.reload('6f20a9a1', component.options)
    }
    module.hot.accept("./r-trader-order-table.vue?vue&type=template&id=6f20a9a1", function () {
      api.rerender('6f20a9a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-order-table.vue"
export default component.exports